import pako from 'pako';

export function Decoder(encryptData) {
  if (!encryptData) {
    return null;
  } else {
    const binaryString = window.atob(encryptData);
    const byteArray = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
      byteArray[i] = binaryString.charCodeAt(i);
    }
    let data = byteArray.buffer;
    let array = pako.inflate(data);
    let strData = '';
    let chunk = 8 * 1024;
    let i;
    for (i = 0; i < array.length / chunk; i++) {
      strData += String.fromCharCode.apply(null, array.slice(i * chunk, (i + 1) * chunk));
    }
    strData += String.fromCharCode.apply(null, array.slice(i * chunk));
    let jsonResult = decodeURIComponent(escape(strData));
    const decryptedData = JSON.parse(jsonResult);
    return decryptedData;
  }
}
